import type { Message, RequestProgress, SendMessageCallbacks } from './Communication';
import type { Brakesman } from './Filesystem/Helper';
import type { SharePayloadEntry, ShareableEntry } from './ShareUtils';
import type { Lock } from '@easterngraphics/wcf/modules/utils/async';

import { cancelDownload } from './AppAction';
import { MessageTimeout, sendMessage } from './Communication';
import { getPayloadEntry } from './ShareUtils';

import { wrapForSingleUse } from '@egr/xbox/utils/Helper';

export function shareText(content: string): Promise<void> {
    return sendMessage<Message<{content: string}>>({
        type: 'share',
        action: 'message',
        arguments: {
            content
        }
    });
}

interface PayloadEntries {
    payload: Array<SharePayloadEntry>;
}

export async function share(
    entry: ShareableEntry,
    writeLock?: Lock,
    brakesman?: Brakesman,
): Promise<void> {
    const payloadEntry: SharePayloadEntry | null = await getPayloadEntry(entry, writeLock, brakesman);

    if (payloadEntry == null) {
        return;
    }

    return shareMultiple([payloadEntry],).promise;
}

export interface ShareRequest {
    promise: Promise<void>;
    cancel: VoidFunction;
}

export function shareMultiple<ProgressType extends RequestProgress = RequestProgress>(
    payload: Array<SharePayloadEntry>,
    progressCallback?: SendMessageCallbacks<ProgressType>['progress'],
    cameraRoll?: boolean,
): ShareRequest {
    let transactionId: number | undefined;
    const promise: Promise<void> = sendMessage<Message<PayloadEntries>, void, ProgressType>(
        {
            type: !cameraRoll ? 'share' : 'camera_roll',
            action: 'content',
            arguments: {
                payload,
            }
        },
        false,
        MessageTimeout,
        {
            transactionId: (value: number): void => {
                transactionId = value;
            },
            progress: progressCallback
        }
    );

    return {
        promise,
        cancel: wrapForSingleUse((): void => {
            if (transactionId != null) {
                return cancelDownload(transactionId);
            }
        })
    };
}